module.exports = __webpack_public_path__ + "img/bg-nosotros-2.50377644.png";